import parse from 'date-fns__legacy__/parse'

const getCardNumber = (number) => {
  const cardNumber = number.substring(number.indexOf('-') + 1, number.length)

  return parseInt(cardNumber)
}

/**
 * @param {ApiRechargeInfo} data
 * @return {RechargeInfo}
 */
export const parseRechargeInfo = (data) => {
  const recharge = {
    amount: data.amount,
    trigger: data.triggerAmount,
    since: parse(data.dateCreated),
    active: data.isActive,
  }

  const card = {
    holder: data.cardHolderName,
    digits: getCardNumber(data.lastCreditCardNumber)
  }

  return { recharge, card }
}

export default {
  parseRechargeInfo
}